<footer class="foot">
    <span>&copy; {{ currentYear }} {{ brand.name }}</span>
</footer>